import type { Category } from '../types/category';

interface CategoryCardProps {
  category: Category;
  recordCount: number;
}

export function CategoryCard({ category, recordCount }: CategoryCardProps) {
  return (
    <div className="bg-white/5 backdrop-blur-sm p-3 rounded-lg hover:bg-white/10 transition-colors cursor-pointer">
      <div className="flex items-center gap-2 min-w-0">
        <span className="text-xl text-[#1DB954] flex-shrink-0">
          <ion-icon name={category.icon}></ion-icon>
        </span>
        <div className="min-w-0">
          <h3 className="text-sm font-medium truncate">{category.title}</h3>
          <p className="text-xs text-gray-400">{recordCount} records</p>
        </div>
      </div>
    </div>
  );
}